import React, { PureComponent } from 'react';
import { select } from 'd3'
import TimelineWidget from './TimelineWidget'
import HoldingsWidget from './HoldingsWidget'
import SectorsWidget from './SectorsWidget'
import PremiumDiscountWidget from './PremiumDiscountWidget'
import './App.css';

class App extends PureComponent {
  constructor() {
    super()
    this.state = {
      width: null,
      resizeListenerId: 'resize.' + String(Math.random()).substr(2, 5)
    }
  }
  componentDidMount() {
    this.updateWidth()
    select(window).on(this.state.resizeListenerId, () => this.updateWidth() )

    /* On WisdomTree.com on a mobile device the widgets can appear in a collapsible section
       that gets shown/hidden when the user clicks its header. This logic detects whether
       we are indeed in such a section and adds a click listener to that header, so that when 
       it's expanded, we can update the size of the widget. Otherwise, the widget will size
       itself based on the width of an invisible div, which is 0.
    */
    detectIfItsWtSiteAndListenForMouseClicks(this.refs.container.parentNode, 'details-section', '.mobile-section-header', () => { this.updateWidth() })

    /* The same requirement applies for the non-mobile website in Canada, which also has multiple
       tabs that contain this widget */
    detectIfItsWtSiteAndListenForMouseClicks(this.refs.container.parentNode, 'tabs-component',  '.tab-headers', () => { this.updateWidth() })
  }
  updateWidth() {
    const container = this.refs.container
    this.setState({
      width: container.getBoundingClientRect().width
    })
  }
  render() {
    const { view, fundTicker, fundName, i18n, lang, embedOptions } = this.props
    const { width } = this.state

    if (!view) {
      /* DO NOT BE CONFUSED!
         This section runs when `view` is null and causes every view to be rendered. This isn't supposed
         to occur if you're embedding widgets using <script> tag. Normally, these get rendered only
         in development, when you view indexl.html. This section is just for rendering the "inventory" of
         all views.
      */
      return (
        <div ref='container' className="App">
          <TimelineWidget width={width} i18n={i18n} lang={lang} fundTicker={fundTicker} fundName={fundName} />
          <br/><br/><br/><br/>
          <PremiumDiscountWidget width={width} i18n={i18n} lang={lang} />
          <br/><br/><br/><br/>
          <SectorsWidget width={width} i18n={i18n} lang={lang} fundTicker={fundTicker} />
          <br/><br/><br/><br/>
          <HoldingsWidget width={width} i18n={i18n} lang={lang} fundTicker={fundTicker} />
        </div>
      );      
    }

    let component = null
    switch (view) {
      case 'performance':
        component = <TimelineWidget
          width={width} i18n={i18n} lang={lang} fundTicker={fundTicker} fundName={fundName}
          fundMarketDataVarName={embedOptions.fundMarketData}
          fundBenchmarksVarName={embedOptions.fundBenchmarks}
          hideVolumeGraph={embedOptions.hideVolumeGraph || false}
          hideMarketOption={embedOptions.hideMarketOption || false}
          hideMarketVsNavSelector={embedOptions.hideMarketVsNavSelector || false}
          hideG10kFootnote={embedOptions.hideG10kFootnote || false}
          g10kFootnoteTextId={embedOptions.g10kFootnoteTextId || 'INFO_G10K'}
        />
        break;
      case 'holdings':
        component = <HoldingsWidget width={width} i18n={i18n} lang={lang} fundTicker={fundTicker} />
        break;
      case 'sectors':
        component = <SectorsWidget width={width} i18n={i18n} lang={lang} fundTicker={fundTicker} />
        break;
      case 'premium-discount':
        component = <PremiumDiscountWidget width={width} i18n={i18n} lang={lang} />
        break;
      default:
        component = <h1>Unknown view {view}</h1>
    }
    return <div ref='container' className={'App ' + view}>{component}</div>
  }
}

export default App;
    
/* On WisdomTree.com, when there are tabs, we need to "walk" up the hierarchy outside of the widget,
   find the common ancestor of the tabs and our widget and subscribe to click events on it, so that
   we can refresh size when a tab is clicked */
function detectIfItsWtSiteAndListenForMouseClicks(containingParent, commonAncestorClassName, clickableElementSelector, callback) {
    while (containingParent && containingParent.getAttribute && !select(containingParent).classed(commonAncestorClassName)) {
      containingParent = containingParent.parentNode
    }
    const containingSection = select(containingParent)
    if (containingParent.getAttribute && containingSection.classed(commonAncestorClassName)) {
      containingSection
        .select(clickableElementSelector)
        .on(`click.${String(Math.random()).substr(2, 5)}`, () => {
          if (process.env.NODE_ENV === 'development') {
            // In PRODUCTION this is done by the pages' own javascript
            containingSection
              .select('.collapse')
              .classed('in', !containingSection.select('.collapse').classed('in'))
          }
          setTimeout(callback, 0)
        })
    }
}



// WEBPACK FOOTER //
// ./src/App.js